import { createFileRoute } from '@tanstack/react-router';
import { ConfigurationPage } from '@/features/operator/configuration-page';

export const Route = createFileRoute('/operator/configuration')({
    staticData: {
        crumbs: [{ label: 'shell.operatorConsole', to: '/operator' }, { label: 'operator.nav.configuration' }],
    },
    component: ConfigurationPage,
});
